import type { WhitelabelTemplateValue } from "@src/config/featureFlags"
import { FeatureFlagsContext } from "@src/providers/FeatureFlagsProvider"
import { useContext } from "react"

export const referralMap: Record<WhitelabelTemplateValue, string> = {
  "near-intents": "veax.near",
  solswap: "veax.near",
  dogecoinswap: "veax.near",
  turboswap: "veax.near",
  trumpswap: "veax.near",
}

export function useIntentsReferral() {
  const { whitelabelTemplate } = useContext(FeatureFlagsContext)
  return referralMap[whitelabelTemplate]
}
